import React, { MutableRefObject } from 'react';
import Portal from '../Portal';
import styled, { css } from 'styled-components';
import { ReactComponent as CloseCross } from './closeCross.svg';

const body = document.querySelector('body');
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  z-index: 1000;
  overflow: auto;
`;

const ModalWrap = styled.div`
  padding: 25px 20px 25px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  min-height: 100%;
  background: rgba(9, 21, 38, 0.6);
`;
const ModalWindow = styled.div<any>`
  background: #fff;
  border-radius: 10px;
  position: relative;
  ${({ withoutPadding }) =>
    !withoutPadding &&
    css`
      padding: 25px 20px 25px 30px;
    `};
`;

type ModalProps = {
  onClose: () => void;
  modalRef?: MutableRefObject<HTMLElement | undefined>;
  withoutPadding?: boolean;
  disableCloseByClickByOverlay?: boolean;
  customModalWindow?: React.ElementType | keyof JSX.IntrinsicElements | any;
  hideCloseButton?: boolean;
};
export default class Modal extends React.Component<React.PropsWithChildren<ModalProps>> {
  innerRef = { current: null } as { current: HTMLElement | null };
  mousedownTarget: EventTarget | null = null;
  mouseupTarget: EventTarget | null = null;
  handleClose = () => {
    this.props.onClose && this.props.onClose();
  };
  handleEscape = (e: KeyboardEvent) => {
    if (this.props.disableCloseByClickByOverlay) return;
    if (e.keyCode === 27) this.handleClose();
  };
  handleClickOverlay = (e: React.MouseEvent) => {
    if (this.props.disableCloseByClickByOverlay) return;
    if (e.type === 'mousedown') {
      this.mousedownTarget = e.target;
    } else if (e.type === 'mouseup') {
      this.mouseupTarget = e.target;
    } else if (e.currentTarget === this.mousedownTarget && e.currentTarget === this.mouseupTarget) {
      this.handleClose();
    }
  };
  componentDidMount() {
    document.addEventListener('keydown', this.handleEscape);
    body?.classList.add('noScrollBody');
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscape);
    body?.classList.remove('noScrollBody');
  }
  setRef = (ref: HTMLElement) => {
    this.innerRef.current = ref;
    if (this.props.modalRef) {
      this.props.modalRef.current = ref;
    }
  };
  render() {
    const { withoutPadding } = this.props;
    const MW = this.props.customModalWindow || ModalWindow;

    return (
      <Portal>
        <Overlay>
          <ModalWrap
            onMouseDown={this.handleClickOverlay}
            onMouseUp={this.handleClickOverlay}
            onClick={this.handleClickOverlay}
          >
            <MW withoutPadding={withoutPadding} ref={this.setRef}>
              {!this.props.hideCloseButton && (
                <CloseCross style={{ position: 'absolute', right: -30, top: 7 }} onClick={this.handleClose} />
              )}
              {this.props.children}
            </MW>
          </ModalWrap>
        </Overlay>
      </Portal>
    );
  }
}
